export const formatDate = (date: Date) => {
  const weekDay = date.toLocaleString('nl-NL', { weekday: 'long' });
  const weekNumber = date.getDate();
  const month = date.toLocaleString('nl-NL', { month: 'long' });

  return `${weekDay} ${weekNumber} ${month}`;
};

export const monthDiff = (d1: Date, d2: Date) => {
  let months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth();
  months += d2.getMonth();
  return months;
};

export const initiateDate = (dateParams: string | number | Date = new Date(), resetDate = true) => {
  const date = new Date(dateParams);

  if (resetDate) {
    date.setDate(1);
  }

  return date;
};

export const doubleDigits = (number: number) => {
  return (`0${number}`).slice(-2);
};
